"use strict";
var r, e;
function f() {
  return e || (e = 1, r = ReferenceError), r;
}
export {
  f as __require
};
//# sourceMappingURL=index.es307.js.map
